<template>
  <header
    :data-sb-automation="$attrs['data-sb-automation'] || 'sb-page-header'"
    data-sb-regression="sb-page-header"
    :class="classes"
  >
    <div
      data-sb-automation="sb-page-header-content"
      :class="{
        'sb-page-header__container': true,
        'sb-page-header__container--narrow': layout === 'narrow',
        'sb-page-header__container--wide': layout === 'wide',
        'sb-page-header__container--tabs': $slots['tabs'],
      }"
    >
      <div>
        <!--
          * To render breadcrumbs provided
        -->
        <div
          data-sb-automation="sb-page-header-breadcrumbs"
          class="sb-page-header__breadcrumbs"
        >
          <span
            v-for="crumb in breadcrumbs"
            :key="crumb"
          >
            <SbBackLink
              :to="crumb.to"
              :href="crumb.href"
              :type="crumb.href ? 'button' : 'router-link'"
            >
              {{ crumb.text }}
            </SbBackLink>
          </span>
        </div>

        <h2
          data-sb-automation="sb-page-header-title"
          class="sb-page-header__title"
        >
          <!--
            @slot Slot for custom title content (overrides title prop)
            @ignore
          -->
          <slot name="title">
            <SbText :value="title" />
          </slot>
        </h2>
        <span
          data-sb-automation="sb-page-header-subtitle"
          class="sb-page-header__subtitle"
        >
          <!--
            @slot Slot for custom subtitle content (overrides subTitle prop)
          -->
          <slot name="subtitle">
            <SbText :value="subTitle" />
          </slot>
        </span>
      </div>

      <div
        data-sb-automation="sb-page-header-call-to-action"
        class="sb-page-header__action"
      >
        <!--
          @slot Slot to show call to action of the page header
        -->
        <slot name="call-to-action" />
      </div>
      <div
        v-if="$slots['tabs']"
        class="sb-page-header__tabs"
        data-sb-automation="sb-page-header-tabs"
      >
        <!--
          @slot Slot to show tabs needed in the header
        -->
        <slot name="tabs" />
      </div>
    </div>
  </header>
</template>

<script>
import SbText from '@src/components/Text/SbText.vue';
import SbBackLink from '@src/components/BackLink/SbBackLink.vue';
/**
 * Page Headers are header containers.
*/
export default {
  name: 'SbPageHeader',
  components: { SbText, SbBackLink },
  props: {
    /**
     * Title of the Page
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * Sub Title or the Description of the Page
     */
    subTitle: {
      type: String,
      default: '',
    },
    /**
     * Breadcrumbs to show above header.
     * Accepted Format: [{to: RouterLink, text: String}, { href: String, text: String }]
     * @values Array<{to?: RouterLink, href?: string, text: string}>
     */
    breadcrumbs: {
      type: Array,
      default: () => ([]),
    },
    /**
     * Layout type for the page header container
     * Accepted values: `narrow`, `wide`, `fluid`
     * @values [narrow, wide, fluid]
     */
    layout: {
      type: String,
      default: 'fluid',
      validator: (value) => {
        return value.match(/(narrow|wide|fluid)/);
      },
    },
  },
  computed: {
    classes() {
      return ['sb-page-header'];
    },
  },
  mounted() {
    this.checkSlotAndProp('title');
    this.checkSlotAndProp('subtitle');
  },
  methods: {
    checkSlotAndProp(prop) {
      if (this.$slots[prop] && this[prop]) {
        console.warn(`Both slot and property are provided for ${prop}. Property will be ignored`);
      }
      return undefined;
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@src/layout/PageHeader/style/sb-page-header.scss';
</style>
